var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67682 18.8411L2.8573 19.2252C1.9958 19.6288 0.998955 19.0136 1 18.079L1.01049 5.14213C1.01049 2.58476 2.46485 1 5.07241 1H12.9445C15.5593 1 16.9811 2.58476 16.9811 5.14213L17 18.0759C17.0011 19.0116 16.0042 19.6278 15.1416 19.2231L14.3285 18.8421C13.8394 18.612 13.2739 18.5956 12.7713 18.7969L10.4565 19.7213C9.52367 20.0931 8.47748 20.0931 7.54464 19.7203L5.23401 18.7969C4.73138 18.5956 4.1658 18.612 3.67682 18.8411Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 8.50063C6.25 7.37803 7.04432 6.25 8.2722 6.25H10.6361C11.0503 6.25 11.3861 6.58579 11.3861 7C11.3861 7.41421 11.0503 7.75 10.6361 7.75H8.2722C8.09513 7.75 7.75 7.96503 7.75 8.50063C7.75 9.03458 8.0948 9.25007 8.2722 9.25007H9.72679C10.9551 9.25007 11.75 10.3775 11.75 11.5006C11.75 12.6229 10.9548 13.75 9.72679 13.75H7.36287C6.94866 13.75 6.61287 13.4142 6.61287 13C6.61287 12.5858 6.94866 12.25 7.36287 12.25H9.72679C9.90552 12.25 10.25 12.0341 10.25 11.5006C10.25 10.9656 9.9052 10.7501 9.72679 10.7501H8.2722C7.04465 10.7501 6.25 9.62235 6.25 8.50063Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V7C9.75 7.41421 9.41421 7.75 9 7.75C8.58579 7.75 8.25 7.41421 8.25 7V6C8.25 5.58579 8.58579 5.25 9 5.25Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.b1e5029a38c6829bc0b01ce379bc9ddf.svg";
export { ForwardRef as ReactComponent };